
  import userController from '/home/builduser/agent00/work/13de1c35440c804a/statics/viewer/bookings-service-details-widget/src/components/BookingServicePage/controller.ts';
  import createControllerWrapper from 'yoshi-flow-editor-runtime/build/controllerWrapper.js';

  var sentryConfig = {
    DSN: 'https://dd0a55ccb8124b9c9d938e3acf41f8aa@sentry.wixpress.com/514',
    id: 'dd0a55ccb8124b9c9d938e3acf41f8aa',
    projectName: 'bookings-service-details-wi-wu',
    teamName: 'bookings',
  };

  var experimentsConfig = {"scope":"test"};

  var translationsConfig = {"default":"en","defaultTranslationsPath":"/home/builduser/agent00/work/13de1c35440c804a/statics/viewer/bookings-service-details-widget/src/assets/locales/messages_en.json"};

  var biConfig = {"owner":"bi-logger-editor-flow-template","visitor":"bi-logger-editor-flow-template"};

  var defaultTranslations = {"app.widget.welcome":"Welcome","app.settings.label":"Configure Widget","app.settings.actions.edit":"Edit","app.settings.actions.show":"Show","app.settings.actions.hide":"Hide","app.settings.tabs.main":"Main","app.settings.tabs.sections":"Sections","app.settings.tabs.design":"Design","app.settings.sections.titles.info":"Info Sections","app.settings.sections.items.header.label":"Header","app.settings.sections.items.sidebar.label":"Sidebar","app.settings.sections.items.description.label":"Description","app.settings.sections.items.details.label":"Service Details","app.settings.sections.items.policies.label":"Policies","app.settings.sections.items.schedule.label":"Service Schedule","app.settings.sections.items.title.label":"Service Title","app.settings.sections.items.contact.label":"Contact details"};

  import biLogger from '/home/builduser/agent00/work/13de1c35440c804a/statics/viewer/bookings-service-details-widget/node_modules/bi-logger-editor-flow-template/dist/src/index.js';

  export default createControllerWrapper(userController, {
    sentryConfig,
    biConfig,
    experimentsConfig,
    biLogger,
    translationsConfig,
    appName: "Wix Bookings",
    projectName: "bookings-service-details-widget",
    defaultTranslations,
  });
